import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAccountingCoins1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "accounting-coins" }),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 15.75,
			cy: 8.25,
			r: 7.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M6.375,14.092a1.341,1.341,0,0,0,.843,1.245l2.064.826a1.342,1.342,0,0,1-.5,2.587H6.75"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 8.25,
			y1: 20.25,
			x2: 8.25,
			y2: 18.75
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M5.281,8.867a7.5,7.5,0,1,0,9.853,9.852"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M17.25,5.25H15.217a1.342,1.342,0,0,0-.5,2.587l2.064.826a1.342,1.342,0,0,1-.5,2.587H14.25"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 15.75,
			y1: 5.25,
			x2: 15.75,
			y2: 3.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 15.75,
			y1: 12.75,
			x2: 15.75,
			y2: 11.25
		})
	]
});
export default SvgAccountingCoins1;
